import { Builder, withChildren } from '@builder.io/react'
import { useTranslation } from 'react-i18next'

const CustomBuilderWrapper = (props) => {
  const { 
    children, 
    wrapperClasses = '', 
    hideOnDomains = '',
    hideOnLanguages = ''
  } = props

  const { i18n } = useTranslation()
  
  try {
    const lang = i18n?.language || 'en'
    const currentHost = window.location?.host?.toLowerCase() || ''

    // Parse arrays from CMS inputs with error handling
    const hideDomainsArray = (hideOnDomains || '')
      .split(',')
      .map((domain) => domain?.trim()?.toLowerCase())
      .filter(Boolean)

    const hideLanguagesArray = (hideOnLanguages || '')
      .split(',')
      .map((language) => language?.trim()?.toLowerCase())
      .filter(Boolean)

    // Hide if current domain or language is in the hide lists
    if (hideDomainsArray.includes(currentHost) || hideLanguagesArray.includes(lang.toLowerCase())) {
      return null
    }

    return <div className={wrapperClasses}>{children}</div>
  } catch (error) {
    console.error('CustomBuilderWrapper error:', error)
    // Fallback: show the component if there's an error
    return <div className={wrapperClasses}>{children}</div>
  }
}

const WrapperWithChildren = withChildren(CustomBuilderWrapper)

Builder.registerComponent(WrapperWithChildren, {
  name: 'CustomBuilderWrapper',
  canHaveChildren: true,
  inputs: [
    {
      name: 'wrapperClasses',
      type: 'string',
      friendlyName: 'Tailwind Classes for Wrapper',
    },
    {
      name: 'hideOnDomains',
      type: 'string',
      friendlyName: 'Hide on Domains (comma-separated)',
      helperText: 'Enter comma-separated domains (e.g., matwproject.org,matwproject.org.uk) where this component should be hidden.',
    },
    {
      name: 'hideOnLanguages',
      type: 'string',
      friendlyName: 'Hide on Languages (comma-separated)',
      helperText: 'Enter comma-separated language codes (e.g., fr,ar,de) where this component should be hidden.',
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'Text',
        options: {
          text: 'Custom Builder Wrapper',
        },
      },
    },
  ],
})

export default CustomBuilderWrapper